type RelativeTimeTokenFormatter = (
  value: number,
  withoutSuffix: boolean,
  key: string,
  isFuture: boolean,
) => string;

type RelativeTimeWrapper = string | ((value: string) => string);

type RelativeTimeLocale = {
  future: RelativeTimeWrapper;
  past: RelativeTimeWrapper;
  s: RelativeTimeTokenFormatter;
  m: RelativeTimeTokenFormatter;
  mm: RelativeTimeTokenFormatter;
  h: RelativeTimeTokenFormatter;
  hh: RelativeTimeTokenFormatter;
  d: RelativeTimeTokenFormatter;
  dd: RelativeTimeTokenFormatter;
  M: RelativeTimeTokenFormatter;
  MM: RelativeTimeTokenFormatter;
  y: RelativeTimeTokenFormatter;
  yy: RelativeTimeTokenFormatter;
};

const fixedUnit =
  (label: string): RelativeTimeTokenFormatter =>
  () =>
    label;

const countedUnit =
  (suffix: string): RelativeTimeTokenFormatter =>
  (value) =>
    `${value}${suffix}`;

export const SHORT_EN_RELATIVE_TIME_LOCALE: RelativeTimeLocale = {
  future: (value) => `in ${value}`,
  past: (value) => (value === 'just now' ? value : `${value} ago`),
  s: (_value, _withoutSuffix, _key, isFuture) =>
    isFuture ? 'a few secs' : 'just now',
  m: fixedUnit('1m'),
  mm: countedUnit('m'),
  h: fixedUnit('1h'),
  hh: countedUnit('h'),
  d: fixedUnit('1d'),
  dd: countedUnit('d'),
  M: fixedUnit('1mo'),
  MM: countedUnit('mo'),
  y: fixedUnit('1y'),
  yy: countedUnit('y'),
};
